import {
  ChangePasswordDto,
  ForgotPasswordRequest,
  RegisterRequest,
  ResetPasswordDto,
} from "@models";
import { accountService } from "@services";
import i18n from "../i18n";
import { message } from "@messages";
import { makeAutoObservable, runInAction } from "mobx";

export default class AccountStore {
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  setLoading = (value: boolean) => {
    runInAction(() => {
      this.loading = value;
    });
  };

  async changePassword(request: ChangePasswordDto) {
    this.setLoading(true);
    try {
      await accountService.changePassword(request);
      runInAction(() => {
        this.loading = false;
      });
      message.success(i18n.t("SuccessfullyChanged"));
      return true;
    } catch (error) {
      console.error(error);
      this.setLoading(false);
      return false;
    }
  }

  async register(request: RegisterRequest) {
    this.setLoading(true);
    try {
      await accountService.register(request);
      this.setLoading(false);
      return true;
    } catch (error) {
      console.error(error);
      this.setLoading(false);
      return false;
    }
  }

  async activate(confirmation: string) {
    this.setLoading(true);
    try {
      await accountService.activate(confirmation);
      this.setLoading(false);
      return true;
    } catch (error) {
      console.error(error);
      this.setLoading(false);
      return false;
    }
  }

  public sendPasswordResetCode = async (input: ForgotPasswordRequest) => {
    this.setLoading(true);
    try {
      await accountService.sendPasswordResetCode(input);
      message.success(i18n.t("PasswordResetCodeSent"));
      this.setLoading(false);
      return true;
    } catch (error) {
      console.error(error);
      this.setLoading(false);
      return false;
    }
  };

  public resetPassword = async (input: ResetPasswordDto) => {
    this.setLoading(true);
    try {
      await accountService.resetPassword(input);
      message.success(i18n.t("PasswordSuccessfullyChanged"));
      this.setLoading(false);
      return true;
    } catch (error) {
      console.error(error);
      this.setLoading(false);
      message.error(i18n.t("PasswordChangeError"));
      return false;
    }
  };
}
